export type IBaseEntity = {
	id: string;
	active: boolean;
	created_at?: number;
	created_by?: string;
	updated_at?: number;
	updated_by?: string; // uid
};

export type IBaseUserEntity = IBaseEntity & {
	user_id: string; // uid
};

export * from "./forms";
